import { Directive, HostBinding, Inject, Injector, INJECTOR, Input, OnDestroy, OnInit, Optional } from '@angular/core';
import { AbstractControl, FormDefinition } from 'eurogard-forms';
import { Required } from '@rxap/utilities';
import { ControlContainer, UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { OpenFormWindowMethodDirective } from 'eurogard-form-window-system';
import { WindowRef } from 'eurogard-window-system';
import { FormTableDataSourceDirective } from '../form-table-data-source.directive';
import '@rxap/rxjs';
import { Method } from 'eurogard-pattern';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[rxapFormEditItem]',
  standalone: true,
})
export class FormEditItemDirective<FormData extends Record<string, any>>
  extends OpenFormWindowMethodDirective<FormData>
  implements OnDestroy {

  @HostBinding('attr.type')
  @Input()
  public type = 'button';

  @Input({
    alias: 'rxapFormEditItem',
    required: true,
  })
  public declare method: Method<WindowRef<FormDefinition, FormData>, Partial<FormData>>;

  @Input({required: true})
  public dataIndex!: number;

  private _group!: UntypedFormGroup;

  constructor(
    private readonly parent: ControlContainer,
    private readonly formTableDataSourceDirective: FormTableDataSourceDirective,
    @Optional()
    @Inject(INJECTOR)
      injector: Injector | null = null,
  ) {
    super(injector);
  }

  @Input()
  public getInitialValue = (control: AbstractControl) => control.value;

  @Input()
  public getControlValue = (value: FormData, control: AbstractControl) => value;

  public override execute() {
    this._group = this.getGroup();
    this.initial = this.getInitialValue(this._group);
    super.execute();
  }

  protected override submitted(value: FormData) {
    value = this.getControlValue(value, this._group);
    this._group.patchValue(value);
    this.formTableDataSourceDirective.refresh();
    super.submitted(value);
  }

  private getGroup(): UntypedFormGroup {
    let offset      = 0;
    const paginator = this.formTableDataSourceDirective.paginator;
    if (paginator) {
      offset = paginator.pageSize * paginator.pageIndex;
    }
    const index  = this.dataIndex + offset;
    const parent = this.parent.control as UntypedFormArray;
    if (!parent) {
      throw new Error('The control container control is not defined');
    }
    const group = parent.controls[index] as UntypedFormGroup;
    if (!group) {
      throw new Error(`The table array control has not a control at index '${ index }'`);
    }
    return group;
  }

}


